import React from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { HOTEL_AUTOCOMPLETE_LOAD_MORE_LABEL } from '../../../constants/hotelSearch.constants';

class HotelAutocompleteLoadMore extends React.Component {
  handleMouseDown = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  handleClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (this.props.onLoadMore) this.props.onLoadMore();
  };

  render() {
    if (!this.props.visible) return null;
    return (
      <button
        type="button"
        className="hotel-autocomplete-load-more"
        onMouseDown={this.handleMouseDown}
        onClick={this.handleClick}
      >
        <ExpandMoreIcon className="hotel-autocomplete-load-more-icon" aria-hidden="true" />
        <span>{HOTEL_AUTOCOMPLETE_LOAD_MORE_LABEL}</span>
      </button>
    );
  }
}

export default HotelAutocompleteLoadMore;
